import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breakpointCodes } from 'rp-mq-breakpoints';
import getServiceProperty, {
  SERVICE_ID_ULTIMATE_MONTHLY,
  SERVICE_ID_ULTIMATE_ANNUAL,
  SERVICE_ID_TIPPING_MONTHLY,
  SERVICE_ID_TIPPING_ANNUAL,
  SERVICE_ID_INSIGHTS_ANNUAL,
  SERVICE_ID_INSIGHTS_MONTHLY,
} from '../helpers/getServiceProperty';

const { EXTRA_NARROW, NARROW } = breakpointCodes;

const SERVICE_PERIOD_MONTHLY = {
  title: 'Monthly',
  periodUnit: 'Months',
};
const SERVICE_PERIOD_ANNUALLY = {
  title: 'Annually',
  periodUnit: 'Years',
};

function withServices(
  WrappedComponent,
  { trackBreakpointChange } = { trackBreakpointChange: false },
) {
  const wrappedComponentName =
        WrappedComponent.displayName || WrappedComponent.name || 'Component';

  class WithServices extends Component {
        static displayName = `WithServices(${wrappedComponentName})`;

        static getDerivedStateFromProps({ breakpoint }) {
          const shouldChangeSubscriptionType = [EXTRA_NARROW, NARROW].find(bp => breakpoint === bp);

          if (shouldChangeSubscriptionType && trackBreakpointChange) {
            return {
              servicePeriod: SERVICE_PERIOD_MONTHLY,
            };
          }

          return null;
        }

        constructor(props, context) {
          super(props, context);

          this.state = {
            servicePeriod: SERVICE_PERIOD_MONTHLY,
          };

          this.handleSubscriptionChange = ::this.handleSubscriptionChange;
        }

        handleSubscriptionChange(servicePeriod) {
          this.setState({
            servicePeriod,
          });
        }

        render() {
          return (
            <WrappedComponent
              {...this.props}
              servicePeriod={this.state.servicePeriod}
              trackBreakpointChange={trackBreakpointChange}
              handleSubscriptionChange={this.handleSubscriptionChange}
                />
          );
        }
  }

  function mapStateToProps({ subscriptions: { options }, breakpoint }) {
    const validSubscriptions = options.filter(Boolean);

    const ultimateMonthly = validSubscriptions.find(service => service.id === SERVICE_ID_ULTIMATE_MONTHLY);
    const ultimateAnnual = validSubscriptions.find(service => service.id === SERVICE_ID_ULTIMATE_ANNUAL);

    const tippingMonthly = validSubscriptions.find(service => service.id === SERVICE_ID_TIPPING_MONTHLY);
    const tippingAnnual = validSubscriptions.find(service => service.id === SERVICE_ID_TIPPING_ANNUAL);

    const insightsMonthly = validSubscriptions.find(service => service.id === SERVICE_ID_INSIGHTS_MONTHLY);
    const insightsAnnual = validSubscriptions.find(service => service.id === SERVICE_ID_INSIGHTS_ANNUAL);

    return {
      breakpoint: breakpoint.current.code,
      services: {
        tipping: {
          type: getServiceProperty(SERVICE_ID_TIPPING_ANNUAL, 'type'),
          image: getServiceProperty(SERVICE_ID_TIPPING_ANNUAL, 'image'),
          features: tippingMonthly.features,
          data: [tippingMonthly, tippingAnnual],
        },
        insights: {
          type: getServiceProperty(SERVICE_ID_INSIGHTS_ANNUAL, 'type'),
          image: getServiceProperty(SERVICE_ID_INSIGHTS_ANNUAL, 'image'),
          features: insightsAnnual.features,
          data: [insightsMonthly, insightsAnnual],
        },
        ultimate: {
          type: getServiceProperty(SERVICE_ID_ULTIMATE_ANNUAL, 'type'),
          image: getServiceProperty(SERVICE_ID_ULTIMATE_ANNUAL, 'image'),
          features: ultimateAnnual.features,
          data: [ultimateMonthly, ultimateAnnual],
        },
      },
      periods: [SERVICE_PERIOD_MONTHLY, SERVICE_PERIOD_ANNUALLY],
    };
  }

  return connect(mapStateToProps)(WithServices);
}

export default withServices;
